/**
 * 受注一覧 キャンセル登録
 */
 import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/collections/cancellations`

 const orders_accepts_collection_cancellation = {
  namespaced: true,
  actions: {
    /**
     * キャンセル登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
 }

 export default orders_accepts_collection_cancellation
